import { booleanMap } from '../../../../shared/configs/searchParams';

export const roomByRepeat = {
  extract: (room) => (room.isRepeat ? booleanMap.yes : booleanMap.no),
};

export const valueToContent = {
  [booleanMap.yes]: 'Повторная',
  [booleanMap.no]: 'Первичная',
};
